import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";

import { assignCard } from "../../../../sevices/apiCards";
import FormDialog from "../../../../components/Dialog/FormDialog";
import { useBoardUsers } from "../../../../utils/reactQuery/users";
import { currentUserId, isAdmin } from "../../../../utils/constants";
import { useBoardName } from "../../../../utils/reactQuery/boards";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import CommentForm from "../../../../components/CommentPopUp";
import useToastPromise from "../../../../hooks/useToast";
import { CustomButton } from "../../../../components/Button/Button";
import AvatarDisplay from "./AvatarDisplay";
import UserMenu from "./UserMenu";
import useMutate from "../../../../hooks/useMutate";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";
import { invalidateCardQueries } from "../../../../utils/reactQuery/cards";

function ListAssignCard({
  tooltipName,
  cardId,
  name,
  cardData,
  callback: refetch,
  listView,
  isAccessForAssign = false,
}) {
  const { id: board_id } = useBoardIdByKey();
  const boardId = board_id || cardData?.board_id;
  const queryClient = useQueryClient();
  const [anchorEl, setAnchorEl] = useState(null);
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [assignCardLoading, setAssignCardLoading] = useState(false);
  const open = Boolean(anchorEl);
  const { isLoading: boardLoading, data: boardUsers } = useBoardUsers(boardId);
  const [milestone] = useCustomSearchParams("milestone");
  const currentUserIdVariable = currentUserId();
  const { boardName } = useBoardName(boardId);
  const boardOwnerId = boardName?.data?.data?.responseData?.owner_user_id;

  const accessForAssign =
    isAdmin() ||
    boardOwnerId === currentUserIdVariable ||
    cardData?.assigned_to_user_id === currentUserIdVariable ||
    isAccessForAssign;

  useEffect(() => {
    const sortedUsers =
      boardUsers?.data?.data?.responseData?.sort((a, b) =>
        a?.username?.localeCompare(b?.username)
      ) || [];

    const updatedUsers = sortedUsers?.reduce((acc, user) => {
      if (user?.user_id === cardData?.assigned_to_user_id) {
        // Place the assigned user at the beginning of the array
        acc.unshift(user);
      } else {
        acc.push(user);
      }
      return acc;
    }, []);

    const activeUsers = updatedUsers?.filter((user) => user?.active) || [];
    setUsers(activeUsers);
  }, [boardLoading, boardId, boardUsers, cardData]);

  const handleAvatarClick = (event) => {
    event.stopPropagation();
    if (accessForAssign) setAnchorEl(event?.currentTarget);
  };

  const handleClose = (event) => {
    event?.stopPropagation();
    setAnchorEl(null);
  };
  const { mutate: updateCardmutate } = useMutate(assignCard,[],
    () => {
      invalidateCardQueries(queryClient, boardId, cardData?.card_id, milestone);
      setOpenDialog(false);
    },
    () => {
    },
  );

  const assignUser = (id) => {
    setOpenDialog(true);
    setUserId(id);
  };
  const callback = (event) => {
    event.stopPropagation();
    setAssignCardLoading(true);
    updateCardmutate({
      card_id: cardData?.card_id,
      data: {},
    });
  };

  const closeConfirmation = (event) => {
    event.stopPropagation();
    setOpenDialog(false);
  };

  const handleAssignClick = () => {
    updateCardmutate({
      card_id: cardId,
      data: {
        assigned_to_user_id: currentUserIdVariable,
      },
    });
  };
  return (
    <>
      {userId?.user_id === "null" && openDialog && (
        <FormDialog
          open={openDialog}
          handleClose={closeConfirmation}
          loading={assignCardLoading}
          handleSubmit={callback}
          buttonTxt="Unassign"
          title="Confirmation: Unassign task"
          alignActions="center"
          cancelBtn={true}
          fullWidth={true}>
          <Typography className="align_text_center mb-2">
            Are you sure you want to remove the assignee from this task
          </Typography>
        </FormDialog>
      )}
      {openDialog && userId?.user_id !== "null" && (
        <FormDialog
          open={openDialog}
          handleClose={closeConfirmation}
          title={`Add a note for ${userId?.username}`}
          width="657px">
          <CommentForm
            cardId={cardData?.card_id}
            userId={userId?.user_id}
            onClose={() => setOpenDialog(false)}
            boardId={boardId}
          />
        </FormDialog>
      )}
      <div className="d-flex align-items-center">
        <AvatarDisplay
          tooltipName={tooltipName}
          cardData={cardData}
          name={name}
          handleAvatarClick={handleAvatarClick}
        />

        <div
          className={`${
            listView ? `assignee-name listView-fontColor` : `assignee-name`
          }`}>
          {cardData?.assigned_to_user && (
            <p
              className={`${
                listView ? `assignee-name listView-fontColor` : `assignee-name`
              }`}>{`${cardData?.assigned_to_user?.first_name} ${cardData?.assigned_to_user?.last_name}`}</p>
          )}
        </div>
        <div className="sidebar-assigntome-btn">
          {cardData?.assigned_to_user ? null : (
            <CustomButton onClick={handleAssignClick} className="reset-btn">
              Assign to me
            </CustomButton>
          )}
        </div>
      </div>
      <UserMenu
        users={users}
        assignUser={assignUser}
        anchorEl={anchorEl}
        open={open}
        handleClose={handleClose}
        cardData={cardData}
      />
    </>
  );
}

export default ListAssignCard;
